
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/rockerbox",
      function () {
        return require("private-next-pages/destinations/rockerbox.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/rockerbox"])
      });
    }
  